define('directives/controls/customSelect/CustomSelect',['app', 'settings'], function (app) {
	'use strict';
	app.directive('ngCustomSelect', [
		'BASE_DIRECTIVES_PATH',
		function (BASE_DIRECTIVES_PATH) {
			return {
				scope: {
					remote: '=?',
					onSearch: '=?',
					label: '@',
					outerLabel: '=?',
					options: '=',
					display: '@',
					value: '@',
					change: '=',
					customChange: '&',
					result: '=',
					placeholder: '@',
					styleClass: '@',
					disable: '=',
					id: '=',
					customColor: '=',
					mandatory: '@',
					hideSearch: '@',
					useLocalSearch: '=?',
					avoidSortValues: '=?',
				},
				templateUrl: BASE_DIRECTIVES_PATH + '/controls/customSelect/views/CustomSelect.html',
				controller: [
					'$scope',
					function ($scope) {
						$scope.$watch('result', function (newValue, oldValue) {
							if (newValue === undefined || newValue === oldValue) return;

							if ($scope.change !== undefined) $scope.change($scope.result);
							if ($scope.customChange !== undefined) $scope.customChange();
						});

						$scope.searchTerm;
						$scope.clearSearchTerm = function () {
							$scope.searchTerm = '';
						};

						$scope.onSearchChange = function ($event, searchTerm) {
							!!$scope.onSearch && $scope.onSearch($event, searchTerm);

							if (!!$scope.useLocalSearch) {
								$scope.localSearch(searchTerm);
							}
						};

						$scope.localSearch = function (searchTerm) {
							if (!Array.isArray($scope.options)) {
								$scope.diplayedOptions = [];
								return;
							}

							if (searchTerm !== '') {
								const regex = new RegExp('.*' + searchTerm.toLowerCase() + '.*');
								$scope.diplayedOptions = $scope.options.filter((o) => {
									return regex.test(o.value.toLowerCase());
								});
							} else {
								$scope.diplayedOptions = $scope.options.slice(0); // Create a copy using slice instead of spread
							}
						};

						$scope.onKeydown = function ($event) {
							$event.stopPropagation();
						};

						if ($scope.display === undefined) {
							$scope.display = 'display';
						}

						$scope.$watch('options', function (newValue, oldValue) {
							// CRITICAL FIX: Check if options exists and is an array before ANY operation
							if (!$scope.options) {
								$scope.diplayedOptions = [];
								return;
							}

							// Convert to array if it's not already (safety check)
							var optionsArray = Array.isArray($scope.options) ? $scope.options : [];

							if (optionsArray.length === 0) {
								$scope.diplayedOptions = [];
								return;
							}

							// Create a safe copy of the array
							try {
								$scope.diplayedOptions = optionsArray.slice(0);
							} catch (e) {
								console.error('Error copying options array:', e);
								$scope.diplayedOptions = [];
								return;
							}

							// Sort if needed
							if (!$scope.avoidSortValues) {
								try {
									$scope.diplayedOptions.sort(function (a, b) {
										if (!a || !b || !a[$scope.display] || !b[$scope.display]) {
											return 0;
										}
										var textA = String(a[$scope.display]).toUpperCase();
										var textB = String(b[$scope.display]).toUpperCase();
										return textA < textB ? -1 : textA > textB ? 1 : 0;
									});
								} catch (e) {
									console.error('Error sorting options:', e);
								}
							}
						});

						if ($scope.value === undefined) {
							$scope.value = '__value__';
						}

						if ($scope.outerLabel === undefined) {
							$scope.outerLabel = false;
						}

						$scope.getOptionDisplayOrValue = (option, displayPath, valuePath) => {
							const displayValue = $scope.getValue(option, displayPath);

							if (displayValue === undefined) {
								return $scope.getValue(option, valuePath);
							}

							return displayValue;
						};

						$scope.getValue = function (option, path) {
							var dp = path.split('.');

							var value = option;

							if (path === '__value__') {
								return value;
							}

							if (path !== '.') {
								for (var i = 0; i < dp.length; i++) {
									value = value[dp[i]];
								}
							}

							return value;
						};
					},
				],
			};
		},
	]);
});

